export const SELECT_CUSTOM_STYLE = {
  control: (base: any) => ({
    ...base,
    minWidth: '240px',
    margin: '8px',
    backgroundColor: '#1a1a1d',
    borderColor: '#2f3037',
    borderRadius: '4px',
    '&:hover': {
      borderColor: '#44454f',
    },
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: '#1a1a1d',
  }),
  menuList: (base: any) => ({
    ...base,
    padding: '4px',
    paddingBottom: '60px',
    borderTop: '1px solid #3a3b44',
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'rgba(66, 133, 244, 0.15)'
      : state.isFocused
        ? '#2f3037'
        : 'transparent',
    color: state.isSelected ? '#4285f4' : '#ffffff',
    fontSize: '14px',
    fontWeight: state.isSelected ? 500 : 400,
    padding: '10px 16px',
    borderRadius: '4px',
    margin: '2px 0',
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      backgroundColor: state.isSelected ? 'rgba(66, 133, 244, 0.25)' : '#2f3037',
    },
  }),
  input: (base: any) => ({
    ...base,
    color: '#e4e4e7',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: '#9293a0',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: '#e4e4e7',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};
